// src/pages/Profile/AccountRoles.jsx
import React from 'react';
import { Box, Avatar, Typography, Chip, Stack } from '@mui/material';

const AccountRoles = ({ user, isArabic, displayRoles, isSuperAdmin }) => {
    const { name, user_name, status, is_admin, image } = user;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                gap: 1.5,
            }}
        >
            <Avatar
                src={image?.preview || image?.url || ''}
                alt={name}
                sx={{
                    width: 110,
                    height: 110,
                    bgcolor: 'primary.main',
                    fontSize: 32,
                }}
            >
                {name?.charAt(0)?.toUpperCase()}
            </Avatar>

            <Typography variant="h5" fontWeight={700}>
                {name}
            </Typography>

            <Typography variant="body2" color="text.secondary">
                @{user_name}
            </Typography>

            <Stack
                direction="row"
                spacing={1}
                flexWrap="wrap"
                justifyContent="center"
            >
                <Chip
                    label={
                        status
                            ? isArabic ? 'مفعّل' : 'Active'
                            : isArabic ? 'غير مفعّل' : 'Inactive'
                    }
                    color={status ? 'success' : 'default'}
                    size="small"
                    sx={{ fontWeight: 500 }}
                />

                {is_admin && (
                    <Chip
                        label={isArabic ? 'مدير النظام' : 'Administrator'}
                        color="primary"
                        size="small"
                        sx={{ fontWeight: 500 }}
                    />
                )}

                {isSuperAdmin && (
                    <Chip
                        label={isArabic ? 'المشرف الأعلى' : 'Super Administrator'}
                        color="primary"
                        size="small"
                        sx={{ fontWeight: 500 }}
                    />
                )}
            </Stack>

            {displayRoles.length > 0 && (
                <Stack
                    direction="row"
                    spacing={1}
                    flexWrap="wrap"
                    justifyContent="center"
                    mt={1}
                >
                    {displayRoles.map((role) => (
                        <Chip
                            key={role}
                            label={role}
                            variant="outlined"
                            size="small"
                            sx={{ mt: 0.5 }}
                        />
                    ))}
                </Stack>
            )}
        </Box>
    );
};

export default AccountRoles;
